// create a 404 react page

import Page from "../components/Page";

const NotFound = () => {
    return (
        <div
            style={{
                padding: "15px",
                position: "absolute",
                top: "47.5%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
            }}
        >
            <h1 style={{ fontSize: "3em", marginBottom: "10px" }}>404</h1>
            <h2 style={{ fontSize: "2em" }}>Page not found</h2>
        </div>
    );
};

export default NotFound;
